import { render, staticRenderFns } from "./personalcenter2.vue?vue&type=template&id=24167bc5&scoped=true&"
import script from "./personalcenter2.js?vue&type=script&lang=js&"
export * from "./personalcenter2.js?vue&type=script&lang=js&"
import style0 from "./personalcenter2.vue?vue&type=style&index=0&id=24167bc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24167bc5",
  null
  
)

export default component.exports